export const notificationHeader = [
  "Timestamp",
  "Email status",
  "Whatsapp status",
  "Entity",
  "Recipient",
  "Template name",
  "Notification body",
  "Attachments",
];

export const emailStatus = "Email status";

export const notificationStatuses = [
  {
    status: "processed",
    meaning: "Email accepted by SendGrid and queued for sending.",
  },
  {
    status: "delivered",
    meaning: "Email successfully delivered to recipient’s server.",
  },
  { status: "deferred", meaning: "Temporary failure; email will be retried." },
  {
    status: "bounce",
    meaning: "Email rejected by the recipient’s server; won’t be retried.",
  },
  {
    status: "blocked",
    meaning: "Email blocked by the receiving server (e.g., spam filters).",
  },
  {
    status: "dropped",
    meaning:
      "Email not sent due to suppression (e.g., invalid email, unsubscribed).",
  },
  { status: "open", meaning: "Email was opened by the recipient." },
  { status: "click", meaning: "Recipient clicked a link in the email." },
  { status: "unsubscribe", meaning: "Recipient unsubscribed from all emails." },
  {
    status: "group_unsubscribe",
    meaning: "Recipient unsubscribed from a specific email group.",
  },
  {
    status: "group_resubscribe",
    meaning: "Recipient re-subscribed to a specific email group.",
  },
  { status: "spamreport", meaning: "Recipient marked the email as spam." },
];
